export const IP_DUPLICATED_MESSAGE = `IP Address is duplicated. Please verify all IP's.`;